import { Box, ModBox, Text } from '@jfs/ui-new'
import { convertCamelCaseToString } from '../../utils'

export const Details = ({ data }: any) => {
  const keys = data ? Object.keys(data) : []
  if (keys?.length === 0) {
    return null
  }
  return (
    <Box width={'100%'}>
      {keys?.map((key, index) => (
        <ModBox
          flexDirection={'row'}
          show={typeof data[key] === 'string' && key !== 'jiopayOrigTransactionId'}
          justify={'space-between'}
          align={'center'}
          borderTopWidth={index === 0 ? 0 : 1}
          borderTopColor={'DISABLED_GREY'}
          pv={12}
          ph={24}>
          <Text
            title={convertCamelCaseToString(key)}
            fontFamily={'jiotype-medium'}
            color={'PRIMARY_GREY'}
            fontSize={14}
          />
          <Text title={data[key]} textAlign={'right'} fontFamily={'jiotype-medium'} color={'BLACK_21'} fontSize={14} />
        </ModBox>
      ))}
    </Box>
  )
}
